export const error = {
  // 登录
  200001: 'Wallet is not connected',

  // MetaMask
  210001: "Can't find MetaMask",
  210002: "Can't connect to MetaMask",
  210003: 'MetaMask rejected to connect',

  // walletConnect
  220003: "Can't connect to WalletConnect",
  220004: 'WalletConnect failed to connect to network',
  220005: 'WalletConnect failed to disconnect',
  220006: 'User closed WalletConnect QR code',

  230001: 'User denied transaction signature',

  // ledger
  240001: 'No device selected',
  240002: 'No wallet is selected, you need to open the corresponding wallet on your device',
  240003: 'You selected the wrong wallet on your device',
  240004: 'Your ledger has been previously connected and unlocked but is now locked and not accessible.',
  240005: 'The current browser does not support Ledger, please use Chrome browser',
  // 240006: `Transaction has expired due to confirmation timeout. Please re-send the transaction.`,
  240006: 'Failed to connect your Ledger. Reason:  confirmation timeout or Ledger Manager was denied', // 确认操作超时、deny ledger manager
  240007: 'Please enable Contract Data on your Ledger in "Ethereum" > "Settings".', // Please enable Contract data on the Ethereum app Settings
  240008: 'The device was disconnected.',
  240009: 'Unable to claim interface.',

  // trezor
  250001: 'Your browser is not supported. To use Trezor, please choose Chrome and Firefox.',
  250002: 'Failed to load the Trezor popup',
  250003: 'Trezor connection has expired due to user inactivity', // Iframe timeout
  250004: 'Trezor popup was closed', // Popup closed
  250005: 'Permissions were not granted to Trezor', // Permissions not granted
  250006: 'Operation was cancelled', // Cancelled
  250007: 'Error: Manifest not set', // Manifest not set. 多次点击会触发
  250008: 'Error: Device call in progress', // Device call in progress
  250009: 'User cancelled the operation', // Action cancelled by user
  250010: 'Please install Trezor Bridge first.', // Transport is missing
  250011: 'Your Trezor device is being used in another window.', // Device is used in another window
  250012: 'Your Trezor device does not response', // closed device

  // 余额
  300001: "Can't get ETH balance",
  300002: "Can't get ERC20 balance",

  // http
  100001: 'Request failed',
  100002: 'Request timeout, please try again later',
  100003: 'Server did not respond',

  // 未知错误
  400001: 'unknown error',

  // 交易
  500001: 'Transaction failed'
}

class ErrCodeHandle {
  /**
   * 错误码统一处理 实例化
   * @param {function} commonFun - 通用处理方法
   */
  constructor(commonFun) {
    // 通用处理方法
    this.commonFun = commonFun
    // 例外错误码
    this.exceptCode = []
    // 特殊处理错误码
    this.specialCode = {}
  }
  /**
   * 例外不处理错误码
   * @param {array} codeList - 例外不处理错误码列表
   */
  except(codeList) {
    codeList.forEach(item => {
      this.exceptCode.push(String(item))
    })
  }
  /**
   * 增加特殊处理错误码
   * @param {string} code - 特殊处理错误码
   * @param {function} func - 特殊处理方法
   */
  on(code, func) {
    const useCode = String(code)
    if (typeof func !== 'function') {
      return
    }
    this.specialCode[useCode] = func
  }

  /**
   * 处理错误码
   * @param {string|number} code - 错误码
   */
  go(code) {
    const useCode = String(code)
    // 错误码是例外  不处理
    if (this.exceptCode.indexOf(useCode) !== -1) {
      return
    }
    // 如果是特殊错误码  特殊处理
    if (this.specialCode[useCode] !== undefined) {
      this.specialCode[useCode](useCode)
      return
    }
    // 通用处理
    this.commonFun(useCode)
  }
}

// 弹出错误码处理 可以联动i18next
function errMsgAlert(code) {
  let resMsg = ''
  if (error[code] !== undefined) {
    resMsg = error[code]
  }
  console.log(code, '>>>>>', resMsg)
}

/**
 * 抛出标准格式错误
 * @param {Number} code - 错误码
 * @return {{msg: *, code: *}}
 */
export function ErrorInfo(code) {
  let resMsg = ''
  if (error[code] !== undefined) {
    resMsg = error[code]
  }
  return {
    code: code,
    message: resMsg
  }
}

// 通用报错处理
export const errCodeHandle = new ErrCodeHandle(errMsgAlert)
